// extracted by mini-css-extract-plugin
export default {"logo":"AppLogo_logo__45RLA"};